import React from 'react';
import { useTranslation } from 'react-i18next';

import useStudentsFormKey from '../../../hooks/use-students-form-key';
import { SimpleField } from './SimpleField';
import { StudentFieldProps } from '../../../types';

export const StudentFirstNameField: React.FC<StudentFieldProps> = ({ index, touched }) => {
  const { t } = useTranslation('AddStudentsStep');
  const studentsFormKey = useStudentsFormKey();

  return (
    <SimpleField
      name={`${studentsFormKey}.${index}.firstName`}
      label={t('First Name')}
      touched={touched}
      inputProps={{
        'aria-label': `${t('Student')} ${index + 1} ${t('First Name')}`
      }}
    />
  );
};
